<template>
  <v-app-bar
    class="border-bottom"
    clipped-left
    flat
    short
    app >
    <v-row>
      <v-col cols="5" class="d-flex d-md-none py-0 align-center">
        <div class="d-flex justify-md-center align-center">
          <v-icon
            color="primary"
            @click="toggleSidebar">
            mdi-menu
          </v-icon>
        </div>
      </v-col>
      <v-col md="5" class="d-none d-md-flex py-0">
        <v-row v-if="!isProvider" align="center">
          <v-col cols="6" class="py-0">
            <div class="d-none d-md-block">
              <RestaurantSelector />
            </div>
          </v-col>
        </v-row>
        <v-row v-else align="center">
          <v-col cols="6" class="py-0">
            <div class="d-none d-md-block">
              <ProviderSelector />
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="2" class="d-flex justify-center py-0">
        <v-row align="center">
          <v-col>
            <div class="d-flex justify-md-center">
              <img src="logo.svg"/>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="5" class="d-flex justify-end py-0 pr-6">
        <UserMenu />
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import RestaurantSelector from '@/components/elements/RestaurantSelector'
import ProviderSelector from '@/components/elements/ProviderSelector'
import UserMenu from '@/components/elements/UserMenu'

export default {
  components: {
    RestaurantSelector,
    ProviderSelector,
    UserMenu
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isProvider () {
      return this.$store.state.userProvider
    }
  },
  data () {
    return {
      isSidebarOpen: false
    }
  },
  watch: {
    isOpen (isOpen) {
      this.isSidebarOpen = isOpen
    }
  },
  methods: {
    openSideBar () {
      this.isSidebarOpen = true
    },
    closeSidebar () {
      this.isSidebarOpen = false
    },
    toggleSidebar () {
      this.isSidebarOpen = !this.isSidebarOpen
      this.$emit('toggle', this.isSidebarOpen)
    }
  }
}
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
